import {
  CreateSegmentAction,
  ReadSegmentAction,
  ReadSegmentActionFormConfiguration,
  UpdateSegmentAction,
} from '@tinct/core-api-models';
import { ApiClient } from '../api-client/api-client';
import {
  ApiCollectionResponse,
  GetCollectionQueryParams,
  GetQueryByIdParams,
} from '../types';

export class SegmentActionsEndpoint {
  constructor(private client: ApiClient) {}

  async getSegmentAction(
    params: GetQueryByIdParams<ReadSegmentAction>,
  ): Promise<ReadSegmentAction> {
    return this.client.getById<ReadSegmentAction>(
      `/api/v1/segment-actions/${params.id}`,
      params.fields,
    );
  }

  async getSegmentActions(
    params: GetCollectionQueryParams<ReadSegmentAction>,
  ): Promise<ApiCollectionResponse<ReadSegmentAction>> {
    const { fields, offset, limit, filters, sort } = params;
    return this.client.getCollection<ReadSegmentAction>(
      '/api/v1/segment-actions',
      fields,
      {
        offset,
        limit,
        ...filters,
        sort,
      },
    );
  }

  async getFormConfiguration(): Promise<ReadSegmentActionFormConfiguration> {
    return this.client.getById<ReadSegmentActionFormConfiguration>(
      '/api/v1/segment-actions/form-configuration',
    );
  }

  async createSegmentAction(
    body: CreateSegmentAction,
  ): Promise<ReadSegmentAction> {
    return this.client.post<ReadSegmentAction>('/api/v1/segment-actions', body);
  }

  async updateSegmentAction(
    id: string,
    body: UpdateSegmentAction,
  ): Promise<ReadSegmentAction> {
    return this.client.put<ReadSegmentAction>(
      `/api/v1/segment-actions/${id}`,
      body,
    );
  }
}
